import { useMutation } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

type SendTestPushPayload = {
  MarketingCampaignId: number;
  MarketingPushId?: number;
  RecipientEmail: string;
};

export function useSendTestPushMutation() {
  return useMutation({
    mutationFn: async (payload: SendTestPushPayload) => {
      const res = postData({
        endpoint: 'api/push-marketing/test-send-push',
        payload,
      });
      return res;
    },
  });
}
